const appraisalSurvey = {
  getWaiverResults(id) {
    return `/homeowner/appraisal-survey/${id}/waiver-results`;
  }
};

export default appraisalSurvey;
